// extracted by mini-css-extract-plugin
export var active = "_2r-2";
export var container = "_2r-0";
export var expired = "_2r-3";
export var hasStatus = "_2r-4";
export var statusChip = "_2r-1";